import { BASE_URL } from "./ServerEndpointController";
import axios from 'axios';

const ORGANIZATIONS_ENDPOINT = `${BASE_URL}/organizations`;

export async function getOrganizations() {
    try {
        const response = await axios.get(`${ORGANIZATIONS_ENDPOINT}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching organization data:', error);
    }
};

export async function getOrganizationById(organization_id) {
    try {
        const response = await axios.get(`${ORGANIZATIONS_ENDPOINT}/${organization_id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching organization data:', error);
    }
}

export async function deleteOrganization(organization_id) {
    try {
        const response = await axios.delete(`${ORGANIZATIONS_ENDPOINT}/${organization_id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting organization:', error);
    }
}

export async function createOrganization(organization) {
    try {
        const response = await axios.post(`${ORGANIZATIONS_ENDPOINT}/`, organization);
        return response.data;
    } catch (error) {
        console.error('Error creating organization:', error);
    }
}

export async function updateOrganization(organization_id, organization) {
    try {
        const response = await axios.put(`${ORGANIZATIONS_ENDPOINT}/${organization_id}`, organization);
        return response.data;
    } catch (error) {
        console.error('Error updating organization:', error);
    }
}

export async function getOrganizationUsers(organization_id) {
    try {
        const response = await axios.get(`${ORGANIZATIONS_ENDPOINT}/${organization_id}/users`);
        return response.data;
    } catch (error) {
        console.error('Error fetching organization members:', error);
    }
}

export async function getOrganizationSamples(organization_id) {
    try {
        const response = await axios.get(`${ORGANIZATIONS_ENDPOINT}/${organization_id}/samples`);
        return response.data;
    } catch (error) {
        console.error('Error fetching organization samples:', error);
    }
}
